import CoinThreeHeader from "Components/CoinThree/CoinThreeHeader/CoinThreeHeader";
import InvestRealEstate from "Components/CoinThree/InvestRealEstate/InvestRealEstate";
import MVRCoreCoinUtility from "Components/CoinThree/MVRCoreCoinUtility/MVRCoreCoinUtility";
import NextEvolution from "Components/CoinThree/NextEvolution/NextEvolution";
import SEO from "Components/SEO";
import WorldOfMetaverse from "Components/WorldOfMetaverse";
import React from "react";

const CoinThree = () => {
    return (
        <div>
            <SEO />
            <CoinThreeHeader />
            <WorldOfMetaverse />
            <InvestRealEstate />
            <MVRCoreCoinUtility />
            <NextEvolution />
        </div>
    );
};

export default CoinThree;
